const commonAction = {
  setCommontName: 'SETCOMMONTName',
  setHeaderConfig: 'SETHEADERCONFIG',
  setPathname: 'SETPATHNAME'
}

export default commonAction;